import { motion } from "framer-motion";
import { Smartphone, Banknote, MessageSquareText, ScanLine } from "lucide-react";

/* Walk-in customer landing (QR target on the guest counter card). The register
   operator completes onboarding with the "New customer" button — this page is
   what the customer shows at the counter. */
export default function Guest() {
  return (
    <div data-testid="guest-page" className="min-h-screen bg-[#0c0a09] text-stone-200 flex flex-col items-center px-6 py-14">
      <motion.div
        initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="w-full max-w-md text-center"
      >
        <p className="text-[10px] uppercase tracking-[0.4em] text-amber-500">Guest Wallet · No Membership</p>
        <h1 className="mt-4 text-4xl font-black tracking-tight text-stone-100 leading-tight" style={{ fontFamily: "Georgia, serif" }}>
          PAY WITH YOUR PHONE.<br />
          <span className="text-amber-500">SET UP IN 30 SECONDS.</span>
        </h1>
        <p className="mt-4 text-stone-400 text-sm leading-relaxed">
          No app to install. No bank account. No card. Your wallet lives at bgnzn.org
          and opens with your phone number.
        </p>

        <div className="mt-10 space-y-4 text-left">
          {[
            { icon: ScanLine, step: "1", title: "Show this screen at the counter",
              body: "The cashier taps New Customer on the register — that's the whole setup." },
            { icon: Banknote, step: "2", title: "Hand over any cash amount",
              body: "Your bills become digital dollars in your wallet before you leave the counter." },
            { icon: MessageSquareText, step: "3", title: "Your wallet arrives by text",
              body: "Open the link, add Face ID, and every future visit is a one-tap payment." },
          ].map(({ icon: Icon, step, title, body }, i) => (
            <motion.div
              key={step}
              data-testid={`guest-step-${step}`}
              initial={{ opacity: 0, x: -18 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.3 + i * 0.18 }}
              className="flex gap-4 rounded-2xl border border-stone-800 bg-stone-900/60 p-5"
            >
              <div className="flex-none w-10 h-10 rounded-full bg-amber-500/15 border border-amber-500/40 flex items-center justify-center">
                <Icon size={17} className="text-amber-500" />
              </div>
              <div>
                <p className="text-stone-100 font-bold text-sm">{title}</p>
                <p className="text-stone-500 text-xs mt-1 leading-relaxed">{body}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          data-testid="guest-show-strip"
          className="mt-10 rounded-2xl border-2 border-amber-500 bg-amber-500/10 px-6 py-5"
          animate={{ boxShadow: ["0 0 0 0 rgba(238,198,67,0.35)", "0 0 28px 4px rgba(238,198,67,0.18)", "0 0 0 0 rgba(238,198,67,0.35)"] }}
          transition={{ duration: 2.2, repeat: Infinity }}
        >
          <p className="text-amber-400 font-black text-lg uppercase tracking-wide" style={{ fontFamily: "Georgia, serif" }}>
            Show this at the counter
          </p>
          <p className="text-stone-400 text-xs mt-1">The cashier will take it from here</p>
        </motion.div>

        <p className="mt-10 text-stone-600 text-[10px] font-mono tracking-[0.3em] leading-relaxed">
          GUEST TRANSACTIONAL WALLET · PURCHASES & CASH-OUT ONLY<br />BOURG MERCHANT EXCHANGE · CHAIN 9940
        </p>
        <a href="/" className="mt-4 inline-flex items-center gap-2 text-xs text-stone-500 hover:text-amber-500 transition-colors">
          <Smartphone size={12} /> already have a wallet? sign in
        </a>
      </motion.div>
    </div>
  );
}
